// extracted by mini-css-extract-plugin
module.exports = {"primaryActions":"PrimaryActionsLegacy_primaryActions__S_vjm","noGap":"PrimaryActionsLegacy_noGap__O311a"};